import __env from '../../../env'
import axios from 'axios'
import instance from '../../../middleware/axiosInstance'

// export const GetAllMyAsset = () => {
//   return instance.get(
//     `${process.env.REACT_APP_BACKEND_URL}/my-asset/video-clip`
//   )
// }

export const GetAllTts = pageable => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/tts/get-all?page=${pageable.pageNo}&size=${pageable.pageSize}&sortDir=${pageable.sortDir}&searchBy=`, { withCredentials: true }
  )
}


export const GetGlobalTts = (pageable, search) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/global/tts/get/all?page=${pageable.pageNo}&size=${pageable.pageSize}&sortDir=${pageable.sortDir}&searchBy=${search}`, { withCredentials: true }
  )
}


export const GetTemplateTts = (pageable, search, videoPartIdentifier) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/template/tts/get/all?page=${pageable.pageNo}&size=${pageable.pageSize}&sortDir=${pageable.sortDir}&searchBy=${search}&workflowName=${videoPartIdentifier}`, { withCredentials: true }
  )
}


export const GetTemplateOverlay = (pageable, search, workflow) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/overlay/get/all?page=${pageable.pageNo}&size=${pageable.pageSize}&sortDir=${pageable.sortDir}`, { withCredentials: true }
  )
}

export const GetAllLipSynced = (pageable, search, videoPartIdentifier) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/ls/get/all?page=${pageable.pageNo}&size=${pageable.pageSize}&sortDir=${pageable.sortDir}&searchBy=${search}&videoPartIdentifier=${videoPartIdentifier}`, { withCredentials: true }
  )
}


export const GetAllVoiceCloned = (pageable, search, videoPartIdentifier) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/vc/get/all?page=${pageable.pageNo}&size=${pageable.pageSize}&sortDir=${pageable.sortDir}&searchBy=${search}&videoPartIdentifier=${videoPartIdentifier}`, { withCredentials: true }
  )
}


export const GetAllTransliterationloned = pageable => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/tl/get-all?page=${pageable.pageNo}&size=${pageable.pageSize}&sortDir=${pageable.sortDir}&searchBy=`, { withCredentials: true }
  )
}
export const GetAllKden = (pageable, search) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/mlt/page?pageNo=${pageable.pageNo}&pageSsize=${pageable.pageSize}&sortDir=${pageable.sortDir}&videoPartIdentifier=${search}`, { withCredentials: true }
  )
}

export const GetAllFinalVideos = pageable => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/upload/page?pageNo=${pageable.pageNo}&pageSize=${pageable.pageSize}&sortDir=${pageable.sortDir}&sortBy=${pageable.sortBy}&searchBy=${pageable.search}`, { withCredentials: true }
  )
}

export const GetFinalVideosList = (searchOptions,pageable) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/request/videos/page?useCaseId=${searchOptions?.useCaseId}&userId=${searchOptions?.userId}&status=${searchOptions?.status}&pageSize=${pageable.pageSize}&pageNo=${pageable.pageNo}&batchName=${searchOptions?.batchName}`,{withCredentials:true}
  )
}

export const GetUsecaseOutputList = (pageable, useCaseName) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/request/case/stats?useCaseName=${useCaseName}&page=${pageable.pageNo}&size=${pageable.pageSize}`, { withCredentials: true }
  )
}

export const ChangeAllTtsStatus = data => {
  return instance.put(
    `${process.env.REACT_APP_CACHE_APPROVE_URL}/approval/tts`,
    data, { withCredentials: true }
  )
}

export const ChangeAllLipSyncedStatus = data => {
  return instance.put(
    `${process.env.REACT_APP_CACHE_APPROVE_URL}/approval/ls`,
    data, { withCredentials: true }
  )
}

export const ChangeVoiceClonedStatus = data => {
  return instance.put(
    `${process.env.REACT_APP_CACHE_APPROVE_URL}/approval/vc`,
    data, { withCredentials: true }
  )
}

export const ChangeTransliterationStatus = data => {
  return instance.put(
    `${process.env.REACT_APP_CACHE_APPROVE_URL}/approval/tl`,
    data, { withCredentials: true }
  )
}

export const GetRegenerateModalList = data => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_APPROVE_URL}/tts/models?language=${data.lang}&gender=${data.gender}`, { withCredentials: true }
  )
}

// export const DashboardCount = (useCaseName) => {
//   return instance.get(
//     `${process.env.REACT_APP_CACHE_URL}/cache/request/count?useCaseName=${useCaseName}`
//   )
// }

export const ChangeRegenerateModalList = data => {
  return instance.post(
    `${process.env.REACT_APP_CACHE_APPROVE_URL}/tts/regenerate`,
    data, { withCredentials: true }
  )
}

export const approveRegenerateModalList = data => {
  return instance.put(
    `${process.env.REACT_APP_CACHE_APPROVE_URL}/approval/tts/update`,
    data, { withCredentials: true }
  )
}

export const deleteOverlay = id => {
  return instance.delete(
    `${process.env.REACT_APP_CACHE_URL}/cache/overlay/delete/${id}`, { withCredentials: true }
  )
}

export const deleteLipSync = id => {
  return instance.delete(
    `${process.env.REACT_APP_CACHE_URL}/cache/ls/delete/${id}`, { withCredentials: true }
  )
}

export const deleteIdentifierLipSync = id => {
  return axios.delete(
    `${process.env.REACT_APP_CACHE_URL}/cache/ls/delete?videoConfigPartIdentifier=${id}`, { withCredentials: true }
  )
}

export const deleteFinalVideo = id => {
  return instance.delete(
    `${process.env.REACT_APP_CACHE_URL}/cache/request/delete/client-request/${id}`, { withCredentials: true }
  )
}
export const deleteVoiceClone = id => {
  return instance.delete(
    `${process.env.REACT_APP_CACHE_URL}/cache/vc/delete/${id}`, { withCredentials: true }
  )
}
export const deleteIdentifierVoiceClone = id => {
  return axios.delete(
    `${process.env.REACT_APP_CACHE_URL}/cache/vc/delete?videoConfigPartIdentifier=${id}`, { withCredentials: true }
  )
}

export const deleteKden = id => {
  return instance.delete(
    `${process.env.REACT_APP_CACHE_URL}/cache/mlt/delete/${id}`, { withCredentials: true }
  )
}

export const deleteGlobalTTS = id => {
  return instance.delete(
    `${process.env.REACT_APP_CACHE_URL}/cache/global/tts/delete/${id}`, { withCredentials: true }
  )
}

export const deleteTemplateTTS = id => {
  return instance.delete(
    `${process.env.REACT_APP_CACHE_URL}/cache/template/tts/delete/${id}`, { withCredentials: true }
  )
}

export const deleteIdentifierTemplateTTS = videoPartIdentifier => {
  return axios.delete(
    `${process.env.REACT_APP_CACHE_URL}/cache/template/tts/delete?videoConfigPartIdentifier=${videoPartIdentifier}`, { withCredentials: true }
  )
}

export const deleteTransliteration = id => {
  return instance.delete(
    `${process.env.REACT_APP_CACHE_URL}/cache/names/delete/${id}`, { withCredentials: true }
  )
}

export const deleteTemplateTransliteration = id => {
  return instance.delete(
    `${process.env.REACT_APP_CACHE_URL}/cache/names/delete/${id}`, { withCredentials: true }
  )
}

export const GetNamesTransliterationloned = (pageable = {}, search = "") => {
  console.log("pageable", pageable);
  
  const {
    pageNo = 0,
    pageSize = 10,
    sortBy = "createdDate",
    sortDir = "desc"
  } = pageable;

  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/names/get/all?page=${pageNo}&size=${pageSize}&sortDir=${sortDir}&sortBy=${sortBy}&searchBy=${search}`,
    { withCredentials: true }
  );
};


export const GetPhrasesTransliterationloned = (pageable, search) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/phrases/get/all?page=${pageable.pageNo}&size=${pageable.pageSize}&sortDir=${pageable.sortDir}&searchBy=${search}`, { withCredentials: true }
  )
}

export const GetTemplateSpecificTransliterationloned = (pageable, search) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/template/phrases/get/all?page=${pageable.pageNo}&size=${pageable.pageSize}&sortDir=${pageable.sortDir}&searchBy=${search}`, { withCredentials: true }
  )
}


export const UploadGlobalCsv = data => {
  return instance.post(
    `https://admin.cloud.whilter.ai/admin/global-names/bulk`, data, { withCredentials: true }
  )
}

// export const GetMyAssetList = pageable => {
//   return instance.get(
//     `${process.env.REACT_APP_BACKEND_URL}/my-asset/video-clip/list/paging?pageNo=${pageable.pageNo}&pageSize=${pageable.pageSize}&sortBy=${pageable.sortBy}&sortDir=${pageable.sortDir}&search=${pageable.search}`
//   )
// }


export const downloadLipSyncCsv = workflowName => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/ls/download/lipsync?workflowName=${workflowName}`, { withCredentials: true }
  )
}

export const downloadTtsCsv = workflowName => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/template/tts/template-tts-cache-csv?workflowName=${workflowName}`, { withCredentials: true }
  )
}

export const downloadVcCsv = workflowName => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/vc/template-vc-cache-csv?workflowName=${workflowName}`, { withCredentials: true }
  )
}

// export const regenerateFailedVideo=(useCaseId)=>{
//   return instance.post(
//     `${process.env.REACT_APP_CACHE_APPROVE_URL}/video/request/regenerate?useCaseId=${useCaseId}`,{withCredentials:true}
//   )
// }

export const regenerateFailedVideo = (useCaseId) => {
  return instance.post(
    `${process.env.REACT_APP_CACHE_URL}/cache/regenerate/request?useCaseId=${useCaseId}`, { withCredentials: true }
  )
}

export const downloadFinalVideoCsv = (usecaseId,batchName,status) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/request/download/videos?useCaseId=${usecaseId}&batchName=${batchName}&status=${status}`, { withCredentials: true }
  )
}

export const testBatches = (usecaseId,status) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/iterations/get/videos/test?use-case-id=${usecaseId}&status=${status}`, { withCredentials: true }
  )
}

export const goodToScale = (batchId,status) => {
  return instance.put(
    `${process.env.REACT_APP_CACHE_URL}/cache/iterations/scale?id=${batchId}&scale=${status}`, { withCredentials: true }
  )
}

export const uploadBatchCsv = data => {
  return instance.post(
    `https://csv.prod.whilter.ai/csv/upload/cache`, data, { withCredentials: true }
  )
}


export const approveVideo = (videoId, status) => {
  return instance.put(
    `${process.env.REACT_APP_CACHE_URL}/cache/request/video/approval?id=${videoId}&status=${status}`, { withCredentials: true }
  )
}

export const approveBatch = (batchId, status) => {
  return instance.put(
    `${process.env.REACT_APP_CACHE_URL}/cache/iterations/approval?id=${batchId}&status=${status}`, { withCredentials: true }
  )
}

export const submitComment = (comment, id) => {

  return instance.post(
    `${process.env.REACT_APP_CACHE_URL}/cache/request/video/comment?id=${id}&comment=${comment}`, {}, { withCredentials: true }
  )
}

export const downloadBatch = (usecaseId, iterationId) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/iterations/download/videos?use-case-id=${usecaseId}&iteration-id=${iterationId}`, { withCredentials: true }
  )
}


